const Report = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-item-category" */ '@/pages/base-info/order-properties/item-category/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-item-category" */ '@/pages/base-info/order-properties/item-category/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-item-category" */ '@/pages/base-info/order-properties/item-category/edit.vue'
  )

export default {
  path: 'item-category',
  meta: {
    label: 'itemController',
    auth: 'itemCategory'
  },
  component: {
    name: 'ItemCategory',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoOrderPropertiesItemCategory',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'BaseInfoCreateOrderPropertiesItemCategory',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'BaseInfoEditOrderPropertiesItemCategory',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
